import React, { FunctionComponent, ReactNode } from "react";
import styles from "./SuccessMessage.module.scss";

import HappyMusic from "./HappyMusic";
import { Success } from "shared/types/success";

const SuccessMessage: FunctionComponent<{
  successType?: string;
  buttons: ReactNode;
}> = ({ successType, buttons }) => {
  return (
    <div className={styles.successMessage}>
      {successType === Success.challengeStarted && (
        <>
          <HappyMusic />
          <h4>Successfully Started</h4>

          <div className={styles.successMessage_content}>
            <h6>Great job! There are few tips for you:</h6>

            <ul>
              <li>
                <p>Create a new repository in Github for your project</p>
              </li>

              <li>
                <p>Check the design on Figma for colors, spacings, fonts,...</p>
              </li>

              <li>
                <p>Checkout Resources for useful tips and inspirations</p>
              </li>

              <li>
                <p>
                  Join{" "}
                  <a
                    href="https://discord.gg/3R6vFeM"
                    rel="noopener noreferrer"
                    target="_blank"
                    style={{ color: "var(--blue)" }}
                  >
                    Discord
                  </a>{" "}
                  to ask for help or help others
                </p>
              </li>
            </ul>

            <div className={styles.successMessage_buttonRow}>{buttons}</div>
          </div>
        </>
      )}
    </div>
  );
};

export default SuccessMessage;
